import axios from 'axios';

const API = axios.create({
  baseURL: 'https://galiticket-production.up.railway.app/api',
});

// Añade el token automáticamente a TODAS las peticiones
API.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Cierra sesión si el token expira (401)
API.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Eventos
export const getEvents = () => API.get('/events');
export const getEventsAll = () => API.get('/events?all=true');
export const getEventById = (id) => API.get(`/events/${id}`);
export const createEvent = (formData) => API.post('/events', formData);
export const deleteEvent = (id) => API.delete(`/events/${id}`);
export const togglePublishEvent = (id) => API.patch(`/events/${id}/publish`);
export const getBusSchedules = (event_id) => API.get(`/events/${event_id}/bus-schedules`);
export const getFinishedEvents = () => API.get('/events/finished');

// Series
export const getSeries = () => API.get('/series');
export const getSeriesBySlug = (slug) => API.get(`/series/${slug}`);
export const getSeriesAdmin = () => API.get('/series/admin/all');

// Tickets
export const buyTickets = (data) => API.post('/tickets/buy', data);
export const getTicketInfo = (code) => API.get(`/tickets/info/${code}`);
export const validateTicket = (code) => API.post(`/tickets/validate/${code}`);
export const getScannedCount = (event_id) => API.get(`/tickets/scanned-count/${event_id}`);
export const getMyTickets = () => API.get('/tickets/my-tickets');
export const createInvitations = (data) => API.post('/tickets/invitations', data);

// Auth
export const loginUser = (data) => API.post('/auth/login', data);
export const registerUser = (data) => API.post('/auth/register', data);
export const getProfile = () => API.get('/auth/profile');
export const updateProfile = (data) => API.put('/auth/profile', data);
export const changePassword = (data) => API.put('/auth/change-password', data);
export const getUserStats = () => API.get('/auth/stats');
export const forgotPassword = (data) => API.post('/auth/forgot-password', data);
export const resetPassword = (data) => API.post('/auth/reset-password', data);

// Ticket Types
export const getTicketTypes = (event_id) => API.get(`/ticket-types/${event_id}`);
export const createTicketTypes = (data) => API.post('/ticket-types', data);
export const buyTicketByType = (data) => API.post('/ticket-types/buy', data);

// Pagos
export const createPaymentSession = (data) => API.post('/payments/create-session', data);
export const confirmPayment = (session_id) => API.get(`/payments/confirm/${session_id}`);
export const sendContactForm = (data) => API.post('/contact', data); 
export const getEventStats = () => API.get('/events/stats');

export const getEventsAdmin = () => API.get('/events/admin/all');

// Genres
export const getGenres = () => API.get('/genres');
export const createGenre = (data) => API.post('/genres', data);